var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1110"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1110"
    },
    "bundlingPackage": "marketplace-assets-app-ui",
    "bundlingPackageVersion": "static-1.21883",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};